import Cookies from 'js-cookie';

export interface EventTracker {
  initialize: () => void;
  remove: () => void;
}

export const gaEventTracker: EventTracker = {
  initialize() {
    // @ts-ignore
    window[`ga-disable-${process.env.GA_ID}`] = false;

    if (document) {
      const headElement = document.querySelector('head');

      if (!headElement) {
        return;
      }

      const gaScriptLoader = document.createElement('script');
      gaScriptLoader.setAttribute('async', '');
      gaScriptLoader.setAttribute(
        'src',
        `https://www.googletagmanager.com/gtag/js?id=${process.env.GA_ID}`
      );

      const gaScript = document.createElement('script');
      gaScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${process.env.GA_ID}', {
          cookie_expires: 15552000, // 6 months
          cookie_update: false,
          anonymize_ip: true
        });
      `;

      headElement.appendChild(gaScriptLoader);
      headElement.appendChild(gaScript);
    }
  },
  remove() {
    // @ts-ignore
    window[`ga-disable-${process.env.GA_ID}`] = true;

    Cookies.remove(`_ga_${process.env.GA_ID?.replace('G-', '')}`, {
      path: '/',
      domain: document.domain
    });
    Cookies.remove('_ga', { path: '/', domain: document.domain });
    Cookies.remove('_gid', { path: '/', domain: document.domain });
    Cookies.remove('_gat', { path: '/', domain: document.domain });
  }
};
